import axiosInstance from './axiosInstance'

export const getProjectSectionTaskNotesByTaskId = (taskId) => {
  return axiosInstance.get(`/project/section-task-notes?taskId=${taskId}`)
}

export const getProjectSectionTaskNoteById = (noteId) => {
  return axiosInstance.get(`/project/section-task-notes/${noteId}`)
}

export const createProjectSectionTaskNote = (data) => {
  return axiosInstance.post('/project/section-task-notes', data)
}

export const updateProjectSectionTaskNote = (noteId, data) => {
  return axiosInstance.put(`/project/section-task-notes/${noteId}`, data)
}

export const deleteProjectSectionTaskNote = (noteId) => {
  return axiosInstance.delete(`/project/section-task-notes/${noteId}`)
}

export const togglePinProjectSectionTaskNote = (noteId) => {
  return axiosInstance.put(`/project/section-task-notes/${noteId}/pin`)
}

export const uploadProjectSectionTaskNoteAttachment = (data, onUploadProgress) => {
  return axiosInstance.post('/project/section-task-notes/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress
  })
}

export const deleteProjectSectionTaskNoteAttachmentById = (data) => {
  return axiosInstance.post('/project/section-task-notes/delete-attachment-by-id', data)
}

export const deleteProjectSectionTaskNoteAttachmentByPath = (data) => {
  return axiosInstance.post('/project/section-task-notes/delete-attachment-by-path', data)
}
